import BaseTotal from '../BaseTotal';

const LineItem = (props) => <BaseTotal pb={4} fontWeight="normal" {...props} />;

LineItem.propTypes = BaseTotal.propTypes;

LineItem.defaultProps = {
  children: null,
};

export default LineItem;
